const staticDebtorRoutes = {
  path: "/",
  name: "debtor-layout",
  component: () => import("@/layouts/AuthorizedClientLayout.vue"),
  meta: {
    requiresAuth: true,
    role: "debtor",
  },
  children: [
    {
      path: "home",
      name: "home",
      component: () => import("@/views/HomeView.vue"),
      meta: {
        requiresAuth: true,
        requiresInternalValidation: false,
        previous: null,
        order: 0,
      },
    },
    {
      path: "required-uploads",
      name: "requiredUploads",
      component: () => import("@/views/RequiredUploads.vue"),
      meta: {
        requiresAuth: true,
        requiresInteraction: true,
        next: null,
        condition: (requiredUploads) => {
          return requiredUploads?.length > 0;
        },
        order: 9,
      },
    },
    {
      path: "overview",
      name: "overview",
      component: () => import("@/views/OverView.vue"),
      meta: {
        requiresAuth: true,
        requiresInternalValidation: true,
        next: null,
        order: 10,
      },
    },
  ],
};

const dynamicDebtorRoutes = [
  {
    path: "general-data",
    name: "generalData",
    component: () => import("@/views/GeneralData.vue"),
    meta: {
      requiresAuth: true,
      requiresInternalValidation: true,
      order: 1,
      // role: "debtor",
    },
  },
  {
    path: "marital-data",
    name: "maritalData",
    component: () => import("@/views/MaritalData.vue"),
    meta: {
      requiresAuth: true,
      requiresInternalValidation: false,
      requiresInteraction: true,
      order: 2,
      // role: "debtor",
    },
  },
  {
    path: "job-data",
    name: "jobData",
    component: () => import("@/views/JobData.vue"),
    meta: {
      requiresAuth: true,
      requiresInternalValidation: true,
      requiresInteraction: true,
      order: 3,
      // role: "debtor",
    },
  },
  {
    path: "selfemployment-data",
    name: "selfemploymentData",
    component: () => import("@/views/SelfemploymentData.vue"),
    meta: {
      requiresAuth: true,
      requiresInternalValidation: true,
      requiresInteraction: false,
      order: 4,
      // role: "debtor",
    },
  },
  {
    path: "income-data",
    name: "incomeData",
    component: () => import("@/views/IncomeData.vue"),
    meta: {
      requiresAuth: true,
      requiresInternalValidation: false,
      requiresInteraction: true,
      order: 5,
      // role: "debtor",
    },
  },
  {
    path: "asset-data",
    name: "assetData",
    component: () => import("@/views/AssetData.vue"),
    meta: {
      requiresAuth: true,
      requiresInternalValidation: false,
      requiresInteraction: true,
      order: 6,
      // role: "debtor",
    },
  },
  {
    path: "tax-data",
    name: "taxData",
    component: () => import("@/views/TaxData.vue"),
    meta: {
      requiresAuth: true,
      order: 7,
      // role: "debtor",
    },
  },
  {
    path: "insolvency-challenge",
    name: "insolvencyChallenge",
    component: () => import("@/views/InsolvencyChallenge.vue"),
    meta: {
      requiresAuth: true,
      order: 8,
      // role: "debtor",
    },
  },
];

const debtorWvpRoutes = {
  path: "/wvp",
  component: () => import("@/layouts/AuthorizedClientLayoutWVP.vue"),
  children: [
    {
      path: "home",
      name: "wvp-home",
      component: () => import("@/views/wvp/Home.vue"),
      meta: {
        requiresAuth: true,
        requiresInternalValidation: false,
        next: "wvp-general-data",
      },
    },
    {
      path: "general-data",
      name: "wvp-general-data",
      component: () => import("@/views/wvp/GeneralData.vue"),
      meta: {
        requiresAuth: true,
        requiresInternalValidation: true,
        previous: "wvp-home",
        next: "wvp-marital-data",
      },
    },
    {
      path: "marital-data",
      name: "wvp-marital-data",
      component: () => import("@/views/wvp/MaritalData.vue"),
      meta: {
        requiresAuth: true,
        requiresInternalValidation: true,
        requiresInteraction: true,
        previous: "wvp-general-data",
        next: "wvp-income-data",
      },
    },
    {
      path: "income-data",
      name: "wvp-income-data",
      component: () => import("@/views/wvp/IncomeData.vue"),
      meta: {
        requiresAuth: true,
        requiresInternalValidation: true,
        requiresInteraction: false,
        previous: "wvp-marital-data",
        next: "wvp-selfemployment-data",
      },
    },
    {
      path: "selfemployment-data",
      name: "wvp-selfemployment-data",
      component: () => import("@/views/wvp/SelfemploymentData.vue"),
      meta: {
        requiresAuth: true,
        requiresInternalValidation: true,
        requiresInteraction: false,
        previous: "wvp-income-data",
        next: "wvp-heritage-data",
      },
    },
    {
      path: "heritage-data",
      name: "wvp-heritage-data",
      component: () => import("@/views/wvp/HeritageData.vue"),
      meta: {
        requiresAuth: true,
        requiresInternalValidation: true,
        requiresInteraction: false,
        previous: "wvp-selfemployment-data",
        next: "wvp-winning-data",
      },
    },
    {
      path: "winning-data",
      name: "wvp-winning-data",
      component: () => import("@/views/wvp/WinningData.vue"),
      meta: {
        requiresAuth: true,
        requiresInternalValidation: true,
        requiresInteraction: false,
        previous: "wvp-heritage-data",
        next: "wvp-overview",
      },
    },
    {
      path: "overview",
      name: "wvp-overview",
      component: () => import("@/views/wvp/OverView.vue"),
      meta: {
        requiresAuth: true,
        previous: "wvp-heritage-data",
        next: null,
      },
    },
  ],
  meta: {
    requiresAuth: true,
    role: "debtor",
  },
};

export { staticDebtorRoutes, dynamicDebtorRoutes, debtorWvpRoutes };
